import { ErrorData } from './error-data';

export interface DomainError {
    message: string;
    code: number;
    title: string;
    context?: unknown;
}

export interface ValidationError {
    detail: string;
    title: string;
    type: string;
    violations: Violation[];
}

export interface Violation {
    errorName: string;
    template: string;
    propertyPath: string;
    title: string;
    type: string;

    /* TODO: REMOVE? */
    code: string;
    initialValue: string;
    message: string;
    translatedMessage: string;
}

export type RequestError = DomainError | ValidationError;

export const isDomainError = (error?: RequestError | ErrorData): error is DomainError =>
    !!(error as DomainError)?.message;

export const isValidationError = (error?: RequestError | ErrorData): error is ValidationError =>
    !!(error as ValidationError)?.violations;
